import { useCallback, useRef } from 'react';

const useStableCallback = <T extends (...args: any[]) => any>(fn: T) => {
  const ref = useRef(fn);
  ref.current = fn;
  return useCallback((...args: Parameters<T>): ReturnType<T> => {
    return ref.current(...args);
  }, []);
};

export default useStableCallback;
